import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Card, Form, Input, Button, Space, message } from 'antd';
import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import { createGenre } from '../../graphql/mutation';

const { TextArea } = Input;

const CreateGenre = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [create, { loading }] = useMutation(createGenre, {
    onCompleted: () => {
      message.success('Genre created');
      navigate('/genres');
    },
    onError: (error) => {
      message.error(`Failed to create: ${error.message}`);
    }
  });

  const handleSubmit = (values) => {
    create({
      variables: {
        name: values.name,
        icon: values.icon,
        prompt: values.prompt,
      }
    });
  };

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/genres')}>
              Back
            </Button>
            <span>Create Genre</span>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ maxWidth: 600 }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter a name' }]}
          >
            <Input placeholder="e.g., Pop, Rock, Jazz" />
          </Form.Item>

          <Form.Item
            label="Icon"
            name="icon"
            rules={[{ required: true, message: 'Please enter an icon' }]}
          >
            <Input placeholder="e.g., emoji or icon code" />
          </Form.Item>

          <Form.Item
            label="Prompt"
            name="prompt"
            rules={[{ required: true, message: 'Please enter a prompt' }]}
          >
            <TextArea rows={4} placeholder="Genre prompt text for generation..." />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={loading}>
              Create Genre
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateGenre;
